export default __webpack_public_path__ + "static/Granola-test-5265cf843cc43766afe63c7cb10f50d2.mp4";